import { Sheet } from '../../../types';
import {
  GridCommand,
  SheetCommand,
  SheetCommandType,
} from '../../../types/commands/sheetCommands/sheetCommands';
import { SheetManagementSet } from '../../../types/sheet/draft';
import {
  freezeGridRanges,
  groupUngroupGridRanges,
  hideUnhideGridRanges,
  resizeGridRanges,
} from '../../grid/gridCommands';
import { createSheetDraft } from '../../sheet/updates';
import { getStaticSheetView } from './sheetCRUD';

export async function executeGridCommand(
  set: SheetManagementSet,
  command: GridCommand
) {
  const { sheetId, type } = command;
  // const sheet = await getStaticSheet(set, sheetId);
  const sheet = await createSheetDraft(sheetId, set);
  const sheetView = getStaticSheetView(set, sheetId);

  if (!sheet) return;

  switch (type) {
    case SheetCommandType.HideGrid:
    case SheetCommandType.UnhideGrid:
      return hideUnhideGridRanges(set, sheet, sheetView, command);
    case SheetCommandType.FreezeGrid:
      return freezeGridRanges(set, sheet, command);
    case SheetCommandType.GroupGrid:
    case SheetCommandType.UngroupGrid:
      return groupUngroupGridRanges(set, sheet, command);
    case SheetCommandType.ResizeGrid:
      return resizeGridRanges(set, sheet, sheetView, command);
  }
}
